import React  from 'react'
import PropTypes from 'prop-types'
import Input from 'shared/components/form/Input/Input.component'

import styles from './AzureInputs.module.scss'

const AmazonS3Inputs = props => {
  const {
    connectionString,
    containerName,
    isFetching,
    isSaving,
    updateExportApiConfig
  } = props

  return (
    <>
      <Input
        className={styles.input}
        title={'Access connection string'}
        value={connectionString}
        onChange={updateExportApiConfig('connectionString')}
        disabled={isFetching || isSaving}
      />
      <Input
        className={styles.input}
        title={'Container name'}
        value={containerName}
        onChange={updateExportApiConfig('containerName')}
        disabled={isFetching || isSaving}
      />
    </>
  )
}

AmazonS3Inputs.propTypes = {
  connectionString: PropTypes.string,
  containerName: PropTypes.string,
  isFetching: PropTypes.bool,
  isSaving: PropTypes.bool,
  updateExportApiConfig: PropTypes.func
}

export default AmazonS3Inputs
